import { SubmissionError } from 'redux-form';
import get from 'lodash/get';
import getErrorMessageObject from '../../../utils/error/getErrorMessageObject';
import {
  APPLY_PROMO_CODE,
  REMOVE_PROMO_CODE,
  SET_PROMO_CODE_ERROR,
} from '../../../constants/actionConstants';
import { URL_PROMOTIONS, URL_PROMOTIONS_V2, URL_REMOVE_PROMOTION } from '../../../constants/endpointConstants';
import errorCodeConstants from '../../../constants/errorCodeConstants';
import handleInconsistentOrderFormState from '../../../utils/orderform/handleInconsistentOrderFormState';
import determineSelectedPaymentType from './selectedPaymentTypeActions';

export const postPromoCodeV2 = body => ({
  type: APPLY_PROMO_CODE,
  request: client => client({ path: URL_PROMOTIONS_V2, config: { body, method: 'POST' } }),
  ...body,
});

export const postPromoCode = body => ({
  type: APPLY_PROMO_CODE,
  request: client => client({ path: URL_PROMOTIONS, config: { body, method: 'POST' } }),
  ...body,
});

export const setPromoCodeError = (message, body, orderSubmissionFailure) => ({
  type: SET_PROMO_CODE_ERROR,
  message,
  body,
  ...orderSubmissionFailure && { orderSubmissionFailure },
});

export const silentlyApplyPromoCode = promoCode => async (dispatch) => {
  await dispatch(postPromoCodeV2({ code: promoCode, silent: true }));
};

export const applyPromoCode = ({ promoCode }) => async (dispatch) => {

  if (!promoCode) {
    dispatch(setPromoCodeError('Please enter a valid promo code'));
    throw new SubmissionError({ promoCode: '' });
  }

  const body = {
    code: promoCode,
  };

  const result = await dispatch(postPromoCode(body));

  if (result.type === `${APPLY_PROMO_CODE}.SUCCESS`) {
    dispatch(determineSelectedPaymentType());
  }

  if (result.type === `${APPLY_PROMO_CODE}.FAILED`) {
    const code = get(result.error, 'code');
    if (
      code === errorCodeConstants.ORDER_FORM_INCONSISTENT_STATE ||
      code === errorCodeConstants.INCOMPLETE_DELIVERY_DETAILS
    ) {
      await dispatch(handleInconsistentOrderFormState());
      return;
    }
  }

  if (result.error) {
    const { message, body } = getErrorMessageObject({ error: result.error });
    dispatch(setPromoCodeError(message, body));
    throw new SubmissionError({ promoCode: '' });
  }
};

export const removePromoCode = item => async (dispatch) => {
  const response = await dispatch({
    type: REMOVE_PROMO_CODE,
    request: client => client({ path: URL_REMOVE_PROMOTION(item.id), config: { method: 'DELETE' } }),
  });

  if (response.type === `${REMOVE_PROMO_CODE}.FAILED`) {

    const code = get(response.error, 'code');
    if (
      code === errorCodeConstants.ORDER_FORM_INCONSISTENT_STATE ||
      code === errorCodeConstants.INCOMPLETE_DELIVERY_DETAILS
    ) {
      await dispatch(handleInconsistentOrderFormState());
    }
  } else {
    dispatch(determineSelectedPaymentType());
  }
};
